module.exports = __webpack_public_path__ + "static/media/lucky_neko.yggdrasil.aaf70a07.jpeg";